import {matchPath} from "react-router";
import {Link} from "react-router-dom";
import {
    CLIENT_PROFILE_AUTHORIZATIONS_PATH,
    CLIENT_PROFILE_CLIENT_REPORTS_PATH,
    CLIENT_PROFILE_CONTACTS_PATH,
    CLIENT_PROFILE_DOCUMENT_FILES_PATH,
    CLIENT_PROFILE_SUBMITTED_REQUEST_PATH,
    CLIENT_PROFILE_PROGRESS_PORTRAITS_PATH,
    CLIENT_PROFILE_REFERRAL_OFFER_PATH,
    CLIENT_PROFILE_UTILIZATION_PATH
} from "./domain";

const CLIENT_PROFILE_ROUTES = (baseUrl: string) => [
    {
        name: 'contactsInfo',
        label: 'Contacts',
        url: `${baseUrl}/${CLIENT_PROFILE_CONTACTS_PATH}`,
    },
    {
        name: 'authorizations',
        label: 'Authorizations',
        url: `${baseUrl}/${CLIENT_PROFILE_AUTHORIZATIONS_PATH}`,
    },
    {
        name: 'clientReports',
        label: 'Client Reports',
        url: `${baseUrl}/${CLIENT_PROFILE_CLIENT_REPORTS_PATH}`,
    },
    {
        name: 'progressPortraits',
        label: 'Progress Portraits',
        url: `${baseUrl}/${CLIENT_PROFILE_PROGRESS_PORTRAITS_PATH}`,
    },
    {
        name: 'documentFiles',
        label: 'Documents/Files',
        url: `${baseUrl}/${CLIENT_PROFILE_DOCUMENT_FILES_PATH}`,
    },
    {
        name: 'submittedRequests',
        label: 'Requests',
        url: `${baseUrl}/${CLIENT_PROFILE_SUBMITTED_REQUEST_PATH}`,
    },
    {
        name: 'referralOffers',
        label: 'Referral Offers',
        url: `${baseUrl}/${CLIENT_PROFILE_REFERRAL_OFFER_PATH}`,
    },
    {
        name: 'utilization',
        label: 'Utilization Hours',
        url: `${baseUrl}/${CLIENT_PROFILE_UTILIZATION_PATH}`,
    },
];

type ClientProfileNavigationTabProps = {
    baseUrl: string;
    hideUtilizationTab: boolean;
    hideProgressPortraitTab: boolean;
}

export const ClientProfileNavigationTab = ({baseUrl, hideUtilizationTab, hideProgressPortraitTab}: ClientProfileNavigationTabProps) => {
    const visibleTabs = CLIENT_PROFILE_ROUTES(baseUrl).filter((tab) =>
        (tab.name !== 'utilization' || !hideUtilizationTab)
        && (tab.name !== 'progressPortraits' || !hideProgressPortraitTab)
    );

    return (
        <div className='flex'>
            {visibleTabs.map((tab) => {
                const isSelected = !!matchPath(window.location.pathname, tab.url);
                const labelCss = isSelected
                    ? 'text-atlantis-100 font-medium border-atlantis-100'
                    : 'text-blue-portal-link font-normal border-transparent';

                return (
                    <Link
                        key={tab.name}
                        id={tab.name}
                        to={tab.url}
                        className={`px-4 py-3 text-sm border-b-2 ${labelCss}`}
                    >
                        {tab.label}
                    </Link>
                );
            })}
        </div>
    );
}
